import React, { type FC } from 'react';
import styled from 'styled-components';
import { Tag, TagGroup } from '@oneaudi/unified-web-components';

type Size = 'sm' | 'md';
type AllowedIcons = 'more' | 'charging';
export interface FilterTagProps {
  readonly id: string;
  readonly onClickHandler: () => void;
  readonly text: string;
  readonly selected?: boolean;
  readonly disabled?: boolean;
  readonly icon?: AllowedIcons;
  readonly dataTestId?: string;
  readonly size?: Size;
  readonly className?: string;
  readonly variant?: 'selectable' | 'removable';
}

export const FilterTag: FC<FilterTagProps> = ({
  id,
  onClickHandler,
  text,
  selected = false,
  disabled = false,
  icon,
  dataTestId,
  size = 'md',
  className,
  variant = 'selectable',
}) => {
  if (variant === 'removable') {
    return (
      <StyledTag
        className={className}
        data-testid={dataTestId}
        margin={[0, 0, 0, 0]}
        size={size}
        variant={variant}
        label={<span translate="yes">{text}</span>}
        onClick={onClickHandler}
      />
    );
  }

  // selectable
  return (
    <StyledTag
      id={id}
      className={className}
      data-testid={dataTestId}
      margin={[0, 0, 0, 0]}
      name={`select ${id}`}
      onChange={() => {}}
      onClick={!disabled ? onClickHandler : undefined}
      size={size}
      variant="selectable"
      label={<span translate="yes">{text}</span>}
      value={id}
      checked={selected}
      disabled={disabled}
      icon={icon}
    />
  );
};

interface StyledTagProps {
  icon?: React.ReactNode;
  checked?: boolean;
}
const StyledTag = styled(Tag)<StyledTagProps>`
  button svg {
    display: block;
  }

  @media (hover: none) and (pointer: coarse) {
    && div:hover {
      background: ${({ theme }) =>
        theme.type === 'legacy' ? `inherit` : theme.colors.tagDefaultBackgroundColor};
      box-shadow: ${({ theme }) =>
        theme.type === 'legacy' ? `inset 0 0 0 1px hsla(33,0%,85%,1)` : 'inherit'};
    }
  }
`;

export const Wrapper = styled(TagGroup)`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: stretch;
  row-gap: var(--spacing-relative-xs);
  column-gap: ${({ theme }) => theme.spacing.fixed100};
  border: 0;
  padding: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    column-gap: var(--spacing-relative-2xs);
    row-gap: var(--spacing-relative-2xs);
  }
`;
